import { useEffect, useState } from 'react';

interface ViewportSize {
  w: number;
  h: number;
}

export default function useViewportSize(): ViewportSize {
  const get = (): ViewportSize => ({ 
    w: window.innerWidth, 
    h: window.innerHeight 
  });
  
  const [size, setSize] = useState<ViewportSize>(get());
  
  useEffect(() => {
    const onResize = () => setSize(get());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  
  return size;
}
